import { createNamedContext } from "../createNamedContext";
const I18nContext = createNamedContext("I18nContext", {
    f: () => "",
    t: () => "",
});
export { I18nContext };
